import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import { ButtonGroup, Button, IconButton, Tooltip, Menu, MenuItem, ThemeProvider } from '@material-ui/core';
import { BsArrowsMove, BsArrowUpRight, BsFillRocketFill, BsFillTrashFill, BsCircle, BsSquare, Bs123, Bs6Circle, BsTable, BsBookFill, BsBoxSeamFill } from 'react-icons/bs';
import { FaImage, FaComments } from 'react-icons/fa';
import { FiRotateCw } from 'react-icons/fi';
import { GiResize } from 'react-icons/gi';
import { GoMirror } from 'react-icons/go';
import { useWhatIf } from './WhatIfProvider';

function WhatIfActions(props) {
	const mainTheme = useSelector(selectMainTheme);
	const [anchorEl, setAnchorEl] = useState(null);

	const { editMode, setEditMode } = useWhatIf();
	const { t } = useTranslation('whatIf');

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const iconButtonClassName = 'p-8 lg:p-14 !min-w-0';
	const iconClassName = 'w-14 h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20';

	return (
		<div className={'flex flex-col sm:flex-row lg:flex-col justify-center items-center ' + (props.className || '')}>
			<ButtonGroup aria-label='outlined button group'>
				<Tooltip title={t('move')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('MOVE')} color={editMode === 'MOVE' ? 'secondary' : 'default'}>
						<BsArrowsMove className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('resize')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('RESIZE')} color={editMode === 'RESIZE' ? 'secondary' : 'default'}>
						<GiResize className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('rotate')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('ROTATE')} color={editMode === 'ROTATE' ? 'secondary' : 'default'}>
						<FiRotateCw className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('mirror')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('MIRROR')} color={editMode === 'MIRROR' ? 'secondary' : 'default'}>
						<GoMirror className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('image')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('IMAGE')} color={editMode === 'IMAGE' ? 'secondary' : 'default'}>
						<FaImage className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('devices')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('DEVICE')} color={editMode === 'DEVICE' ? 'secondary' : 'default'}>
						<BsFillRocketFill className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('line')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('LINE')} color={editMode === 'LINE' ? 'secondary' : 'default'}>
						<BsArrowUpRight className={iconClassName} />
					</IconButton>
				</Tooltip>
			</ButtonGroup>
			<ButtonGroup aria-label='outlined button group'>
				<>
					<Tooltip title={t('Transformer label')}>
						<IconButton className={iconButtonClassName} /*onClick={() => setEditMode('LABEL Transformer')}*/ onClick={handleClick} color={(editMode === 'LABEL Transformer' || editMode === 'LABEL Input' || editMode === 'LABEL Output') ? 'secondary' : 'default'} aria-controls='simple-menu' aria-haspopup='true'>
							<Bs123 className={iconClassName} />
						</IconButton>
					</Tooltip>
					<ThemeProvider theme={mainTheme}>
						<Menu
							id='simple-menu'
							classes={{ paper: 'px-6 items-center' }}
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={handleClose}
							anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
							transformOrigin={{ vertical: 'center', horizontal: 'center' }}>

							<MenuItem className='text-xs w-full text-center' component={Button} onClick={() => { setEditMode('LABEL Transformer'); handleClose(); }} role='button'>Transformer</MenuItem>
							<MenuItem classes={{ root: 'text-center self-center' }} className='text-xs w-full text-center' component={Button} onClick={() => { setEditMode('LABEL Input'); handleClose(); }} role='button'>Input</MenuItem>
							<MenuItem className='text-xs w-full text-center' component={Button} onClick={() => { setEditMode('LABEL Output'); handleClose(); }} role='button'>Output</MenuItem>

						</Menu>
					</ThemeProvider>
				</>
				<Tooltip title={t('circle')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('CIRCLE')} color={editMode === 'CIRCLE' ? 'secondary' : 'default'}>
						<BsCircle className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('rect')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('RECT')} color={editMode === 'RECT' ? 'secondary' : 'default'}>
						<BsSquare className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('sumTable')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('SUMTABLE')} color={editMode === 'SUMTABLE' ? 'secondary' : 'default'}>
						<BsTable className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('document')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('DOCUMENT')} color={editMode === 'DOCUMENT' ? 'secondary' : 'default'}>
						<BsBookFill className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('note')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('NOTE')} color={editMode === 'NOTE' ? 'secondary' : 'default'}>
						<FaComments className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('container')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('CONTAINER')} color={editMode === 'CONTAINER' ? 'secondary' : 'default'}>
						<BsBoxSeamFill className={iconClassName} />
					</IconButton>
				</Tooltip>
				<Tooltip title={t('delete')}>
					<IconButton className={iconButtonClassName} onClick={() => setEditMode('DELETE')} color={editMode === 'DELETE' ? 'secondary' : 'default'}>
						<BsFillTrashFill className={iconClassName} />
					</IconButton>
				</Tooltip>
			</ButtonGroup>
		</div>
	);
}

export default WhatIfActions;